/**
 * @generated SignedSource<<2f85705965a3585cbc836e9147da1ebc>>
 * @relayHash 3d96e93646da973911628e43055a9f08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e401857f7c01e3a1e9f0925bc458239f573445ed8b7119ee7ef804a2ec848c88

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PagesSpaceIdQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type PagesSpaceIdQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type PagesSpaceIdQuery = {
  response: PagesSpaceIdQuery$data;
  variables: PagesSpaceIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PagesSpaceIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PagesSpaceIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3d96e93646da973911628e43055a9f08",
    "id": "e401857f7c01e3a1e9f0925bc458239f573445ed8b7119ee7ef804a2ec848c88",
    "metadata": {},
    "name": "PagesSpaceIdQuery",
    "operationKind": "query",
    "text": "query PagesSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
  }
};
})();

(node as any).hash = "deb46e23288932c7ab718d7f71cc2103";

export default node;
